// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/bonusprogram-" + chunkId + "." + {"1":"1267f85b","2":"5b6866f3","3":"2701daf7","4":"f45041f7","5":"93ebc3f1"}[chunkId] + ".min.js";
};